module.exports = __webpack_public_path__ + "static/media/blob-top.59ecb602.svg";